import { render, staticRenderFns } from "./OrganizationUsersEditItem.vue?vue&type=template&id=573295c9&"
import script from "./OrganizationUsersEditItem.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersEditItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports